interface PromoComponent {
  is_used?: boolean;
  usage_threshold: number;
}

/**
 * Whether an applied promo code's minimum-order threshold is NOT yet reached — i.e. the code is
 * applied but gives no discount, so the "minimum order of €X" notice must be shown.
 *
 * Compare against the SMART-PRICED subtotal (`actualSubtotal` ≈ backend `order.sub_total`), NOT the
 * menu-price `subtotal` (Σ original_price). The label used the latter, which is higher, so it wrongly
 * looked "reached" and stayed hidden even when the backend applied no discount (PROD-407, founder
 * 2026-08-06).
 */
export function isPromoMinimumNotReached(components: PromoComponent[] | undefined, subtotalValue: number): boolean {
  if (!components?.length) {
    return false;
  }

  const component = components.find((entry) => !entry.is_used) ?? components[0];

  return subtotalValue < component.usage_threshold;
}
